import { USER_COOKIE_REFRESH_TOKEN_NAME, USER_COOKIE_TOKEN_NAME } from 'constants/cookie';
import Cookies from 'js-cookie';

export const removeCookieSecureData = () => {
    Cookies.remove(USER_COOKIE_TOKEN_NAME);
    Cookies.remove(USER_COOKIE_REFRESH_TOKEN_NAME);
};
